import styled, { css } from 'styled-components';
import Image from 'next/image';
import { rem } from '~/src/helpers/rem-converter.helper';
import { MAX_767 } from '~/src/styles/tokens/break-points';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { COLORS } from '~/src/styles/tokens/colors';

export const DocumentBlockContainer = styled.div<{ hasToNeedHeight: boolean; }>`
    position: relative;
    width: 100%;
    min-height: ${rem(132)};
    height: ${(p) => (p.hasToNeedHeight ? rem(132) : 'auto')};
    flex-wrap: nowrap;
    border-radius: ${BORDER_RADIUS.biggest20};
    padding: ${rem(12)} ${rem(32)};
    background-color: ${COLORS.constantLightestBlackberry};
    flex-direction: row;
    overflow: hidden;

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            height: auto;
            padding: ${rem(32)} ${rem(24)};
        `,
    )};
`;

export const ImageContainer = styled.div`
    align-items: center;

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            height: fit-content;
            margin-right: ${rem(20)};
        `,
    )};
`;

export const ImageDocumentsLogo = styled(Image)`
    max-width: initial;
`;

export const ContentContainer = styled.div`
    flex-direction: column;
    margin-left: ${rem(32)};
    padding: ${rem(20)} 0;
    height: fit-content;

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            margin-left: 0;
            padding: 0;
            width: 100%;
        `,
    )};
`;

export const DocumentListTitleWrapper = styled.div`
    margin-bottom: ${rem(16)};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            margin-bottom: ${rem(24)};
        `,
    )};
`;

export const DocumentListTitle = styled.h3`
    ${FONTS.wide.medium.size24};
    line-height: ${rem(28)};
    color: ${COLORS.textLightPrimary};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            ${FONTS.wide.medium.size24};
            padding: ${rem(10)} 0;
        `,
    )};
`;

export const DocumentList = styled.div`
    width: 100%;
    gap: ${rem(12)} ${rem(20)};
    height: 100%;

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            gap: ${rem(24)};
            flex-direction: column;
        `,
    )};
`;

export const Document = styled.span`
    ${FONTS.compact.regular.size17};
    color: ${COLORS.textLightPrimaryLink};
    cursor: pointer;
    display: block;
    max-height: 100%;
    
    &:hover {
        text-decoration: underline;
    }

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            display: block;
            width: 100%;
            max-height: ${rem(96)};
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
        `,
    )};
`;
